import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { key: 1 }
const _hoisted_2 = {
  key: 0,
  class: "surface-100 pl-4 pb-2"
}
const _hoisted_3 = {
  key: 1,
  class: "mt-2 ml-5 p-message-icon-position-customized"
}
const _hoisted_4 = { class: "flex align-content-center justify-content-center w-11 ml-4" }
const _hoisted_5 = { class: "p-2 text-base" }
const _hoisted_6 = { class: "font-semibold" }
const _hoisted_7 = {
  key: 2,
  class: "new-event-modal-content"
}
const _hoisted_8 = { class: "new-event-date-time" }
const _hoisted_9 = { class: "new-event-date-time-section align-items-center w-full inline-flex mb-2" }
const _hoisted_10 = ["textContent"]
const _hoisted_11 = { class: "p-error" }
const _hoisted_12 = { class: "p-error" }
const _hoisted_13 = {
  key: 0,
  class: "new-event-date-time-section"
}
const _hoisted_14 = {
  key: 1,
  class: "new-event-date-time-section"
}
const _hoisted_15 = {
  key: 0,
  class: "custom-recurrence__container inline-flex"
}
const _hoisted_16 = { class: "field col required p-0 mr-2" }
const _hoisted_17 = { class: "inline-flex" }
const _hoisted_18 = { class: "field col required p-0 ml-2" }
const _hoisted_19 = { class: "flex gap-1 w-full justify-content-start align-content-center mt-3" }
const _hoisted_20 = { class: "p-error" }
const _hoisted_21 = { class: "p-error" }
const _hoisted_22 = { class: "discipline-selector flex align-items-center mt-4" }
const _hoisted_23 = { class: "p-error" }
const _hoisted_24 = {
  key: 7,
  class: "description-input flex align-items-center mt-4"
}
const _hoisted_25 = { class: "new-event-event-type py-0" }
const _hoisted_26 = {
  key: 0,
  class: "field"
}
const _hoisted_27 = { class: "pt-0 inline-flex align-content-center pb-3" }
const _hoisted_28 = {
  key: 1,
  class: "flex flex-column gap-3"
}
const _hoisted_29 = { class: "field required mt-0" }
const _hoisted_30 = { class: "field" }
const _hoisted_31 = { class: "field required" }
const _hoisted_32 = { class: "p-error" }
const _hoisted_33 = { class: "field required" }
const _hoisted_34 = { class: "p-error" }
const _hoisted_35 = { class: "field required mt-2" }
const _hoisted_36 = {
  key: 0,
  class: "field required mt-2"
}
const _hoisted_37 = { class: "p-error" }
const _hoisted_38 = {
  key: 1,
  class: "field required mt-2"
}
const _hoisted_39 = { class: "p-error" }
const _hoisted_40 = { class: "field required" }
const _hoisted_41 = { class: "p-error" }
const _hoisted_42 = { class: "field required" }
const _hoisted_43 = { class: "p-error" }
const _hoisted_44 = {
  key: 3,
  class: "field required mt-2"
}
const _hoisted_45 = { class: "p-error" }
const _hoisted_46 = {
  key: 4,
  class: "field"
}
const _hoisted_47 = {
  key: 0,
  class: "surface-100 p-3 mb-0 border-round-lg"
}
const _hoisted_48 = { class: "col flex align-items-left" }
const _hoisted_49 = ["onClick", "textContent"]
const _hoisted_50 = ["textContent"]
const _hoisted_51 = { class: "col-fixed" }
const _hoisted_52 = { class: "p-dialog-footer new-event-modal-footer" }
const _hoisted_53 = { class: "flex justify-content-end w-full" }
const _hoisted_54 = {
  class: "flex flex-column font-bold",
  style: 'width:350px'
}
const _hoisted_55 = { class: "mb-2" }

import {
  computed,
  ComputedRef,
  onBeforeMount,
  onMounted,
  onUnmounted,
  reactive,
  Ref,
  ref,
  toRefs,
  unref,
  watch,
  watchEffect,
} from 'vue';
import useVuelidate from '@vuelidate/core';
import { helpers, required, requiredIf, maxValue } from '@vuelidate/validators';
import { Frequency, Options, RRule } from 'rrule';
import Divider from 'primevue/divider';
import Calendar from '@/components/Calendar/Calendar.vue';
import InputNumber from 'primevue/inputnumber';
import FileUpload, { FileUploadUploaderEvent } from 'primevue/fileupload';
import MultiSelect from 'primevue/multiselect';
import Textarea from 'primevue/textarea';
import RadioButton from 'primevue/radiobutton';
import AppSelectButton from '@/components/AppSelectButton/AppSelectButton.vue';
import CalendarOverlappingEvents from '@/components/CalendarOverlappingEvents';
import CalendarWarning from './components/CalendarWarning.vue';
import GroupSessionTypeSelect from './components/GroupSessionTypeSelect.vue';
import EventEvaluationAssessmentsFiles from '../EventEvaluationAssessmentsFiles.vue';
import SelectAttendees from '@/components/MultiSelect/SelectAttendees';
import WeekdayPicker from './components/WeekdayPicker.vue';
import ServiceDateError from './components/ServiceDateError.vue';
import {
  DISCIPLINE_ATTENDEE_REQUIRED_EVENT_TYPE,
  EMIT,
  EVENT_TYPE,
  ABRIDGED_FREQUENCY_INTERVALS,
  TENANT_SETTINGS,
} from '@/enum';
import {
  useAuthStore,
  useCalendarStore,
  useEventsModalsStore,
  useServicesStore,
  useTherapyStore,
  useClinicianOrganizationStore,
  useDocumentsStore,
} from '@/store';
import {
  useDateTime,
  useGetDropdownOptions,
  useGetInitialRRuleObject,
  useGetValuesForRecurrenceDropdown,
  useTenant,
  usePersonTypes,
} from '@/composables';
import type {
  AssessmentData,
  AttendeeDropdownOptionInterface,
  AttendeeSessionTypesData,
  DetailedEventInterface,
  DropdownOptionInterface,
  EventCreationFormInterface,
  ClinicianOrganizationInterface,
  RecurrenceDropdownOption,
} from '@/types';
import { storeToRefs } from 'pinia';
import { CONTRACT_BILLING_TYPE } from '@/enum/contract';
import { DropdownChangeEvent } from 'primevue/dropdown';

interface Props {
  eventToEdit?: DetailedEventInterface;
  eventToEditSelected: boolean;
}

const v$scope = 'event_modal_validation_scope';
const serviceDateErrorKey = 'service_date_error_component';
const sessionTypesTooltip = `Select the session type for each student. Options include: RE (Regular), AC (Approved compensation), ESY (Extended School Year) and MU (Make-up)`;

export default /*@__PURE__*/_defineComponent({
  __name: 'EventModal',
  props: {
    eventToEdit: {},
    eventToEditSelected: { type: Boolean }
  },
  emits: [EMIT.SAVE_NEW_EVENT, EMIT.CLOSE_MODAL, EMIT.SAVE_EVENT_FAILED, EMIT.DOCUMENT_EVENT],
  async setup(__props: any, { emit: __emit }) {

let __temp: any, __restore: any

const emit = __emit;
const props = __props;
const authStore = useAuthStore();
const therapyStore = useTherapyStore();
const serviceStore = useServicesStore();
const documentsStore = useDocumentsStore();
const calendarStore = useCalendarStore();
const eventsModalsStore = useEventsModalsStore();
const clinicianOrganizationStore = useClinicianOrganizationStore();
const $tenant = useTenant();

const timezoneChanged = ref<boolean>(false);
const eventDataSet = ref<boolean>(false);
const caseloadOrganization = ref<ClinicianOrganizationInterface | null>();
const { filteredMessage, isAttendeesSelectedFromDashboard, preSelectedAttendees, preselectedEventType } =
  storeToRefs(eventsModalsStore);

const { eventToEdit, eventToEditSelected } = toRefs(props);
const hostId = computed(() => eventToEdit.value?.host_id || (authStore.user?.id as number));
const orgId = computed(
  () => eventToEdit.value?.attendees[0]?.organizations[0]?.id || (authStore.organizationId as number),
);
const saving = ref<boolean>(false);
const startCalendarModel = ref<Date>(new Date());
const endCalendarModel = ref<Date>(new Date());
const startTimeElement = ref();
const endTimeElement = ref();
const showEvaluationAssessmentsFiles = ref<boolean>(false);
const showWarning = ref<boolean>(false);
const overlappingError = ref<boolean>(false);
const warningMessage = ref<string>();
const warningDetails = ref<string[]>([]);
const showCMWarning = ref<boolean>(false);
const cmWarningMessage = ref<string>();
const eventSessionTypes = ref<DropdownOptionInterface[]>([]);
const serviceProviderOrganizations = ref<ClinicianOrganizationInterface[]>([]);
const filteredServiceProviderOrganizations = computed(() =>
  serviceProviderOrganizations.value.filter((org) => !serviceStore.evalOnlyOrganizations.includes(org.id)),
);
const eventEvaluationTypes = ref<DropdownOptionInterface[]>([]);
const evaluationAssessmentsTypesRequest = ref<AssessmentData[]>([]);
const caseloadManagementTypes = ref<DropdownOptionInterface[]>([]);
const selectedAttendees = ref<AttendeeDropdownOptionInterface[]>([]);
const evaluationAssessments: Ref<DropdownOptionInterface[]> = ref([]);
const eventEvaluationAssessment = ref();
const selectedDisciplineId = ref<number>();
const allowedDateRange = ref({ start: new Date(), end: new Date() });
const originalAllowedDateRange = ref({ start: new Date(), end: new Date() });
const disciplineAttendeeRequiredEventTypes = [...Object.values(DISCIPLINE_ATTENDEE_REQUIRED_EVENT_TYPE)];
const disciplineOnlyRequiredEventTypes = [EVENT_TYPE.IEP_MEETING, EVENT_TYPE.CONSULTATION, EVENT_TYPE.RECORD_REVIEW];
const frequencyIntervals = ref<{ label: ABRIDGED_FREQUENCY_INTERVALS; value: Frequency }[]>([
  { label: ABRIDGED_FREQUENCY_INTERVALS.WEEK, value: RRule.WEEKLY },
  { label: ABRIDGED_FREQUENCY_INTERVALS.MONTH, value: RRule.MONTHLY },
]);
const eventTypes = ref<{ id: number; label: EVENT_TYPE }[]>([]);
const confirmEventOpen = ref(false);
const editEventConditions = ref<'this' | 'future'>('this');
const isSplitCaseload = ref<boolean>(false);
const dateUtil = useDateTime();
const uploadFileEventTypes = [
  EVENT_TYPE.IEP_MEETING,
  EVENT_TYPE.CONSULTATION,
  EVENT_TYPE.RECORD_REVIEW,
  EVENT_TYPE.RESPONSE_TO_INTERVENTION,
];
const evaluationEditAttendees = ref([]);
const { initialRRule } = useGetInitialRRuleObject(
  eventToEdit?.value as DetailedEventInterface,
  eventToEditSelected.value,
);

const eventRRule = ref<Partial<RRule>>(initialRRule.value);

const hostTimezone = computed<string | undefined>(
  () => eventToEdit?.value?.host_timezone_name || authStore?.user?.timezone?.name,
);

const hostTimezoneAbbr = computed<string | undefined>(
  () => eventToEdit?.value?.host_timezone_abbr || authStore?.user?.timezone?.abbr,
);

const { recurrenceOptions, initialSelectedOption } = useGetValuesForRecurrenceDropdown(
  eventRRule as Ref<RRule>,
  eventToEditSelected.value,
);

const changeRRuleTimeZone = () => {
  if (eventRRule.value.options && hostTimezone.value) {
    if (!timezoneChanged.value) {
      const displayStart = useDateTime().formatTimeByTimezone(
        eventToEdit?.value?.start_at as string,
        hostTimezone.value as string,
        true,
      );

      const displayEnd = useDateTime().formatTimeByTimezone(
        eventToEdit?.value?.end_at as string,
        hostTimezone.value as string,
        true,
      );

      eventRRule.value.options.dtstart = new Date(displayStart);
      eventRRule.value.options.until = new Date(displayEnd);
      timezoneChanged.value = true;
    }
  }
};

if (eventToEditSelected.value) {
  startCalendarModel.value = new Date(eventToEdit?.value?.start_at as string);
  endCalendarModel.value = new Date(eventToEdit?.value?.end_at as string);
  if (eventToEdit?.value?.start_at && hostTimezone.value) {
    changeRRuleTimeZone();
  }
} else {
  startCalendarModel.value = eventsModalsStore.preSelectedEventStartAt
    ? new Date(eventsModalsStore.preSelectedEventStartAt as Date)
    : new Date();
  if (eventsModalsStore.preSelectedEventStartAt) {
    (eventRRule.value.options as RRule['options']).dtstart = startCalendarModel.value;
  }
  endCalendarModel.value = eventsModalsStore.preSelectedEventStartAt
    ? new Date(eventsModalsStore.preSelectedEventStartAt as Date)
    : new Date();
  endCalendarModel.value.setMinutes(endCalendarModel.value.getMinutes() + 30);
  if (eventsModalsStore.preSelectedEventStartAt) {
    (eventRRule.value.options as RRule['options']).until = endCalendarModel.value;
    eventsModalsStore.preSelectedEventStartAt = undefined;
  }
}

// This ref is where the recurrence dropdown info is stored. It gets updated anytime the eventRRule
// ref has its start or end date altered
const rRuleRef: Ref<{ id: number; value: Partial<RRule>; label: string } | undefined> = ref(initialSelectedOption);

const isCustomRecurrence: ComputedRef<boolean> = computed(() => rRuleRef?.value?.id === 5);
const isRecurring: ComputedRef<boolean> = computed(() => (rRuleRef?.value?.id as number) > 0);
const loading = computed(
  () => calendarStore.loading || eventsModalsStore.loading || saving.value || !eventTypes.value.length,
);

const isElumaClinician = computed(() => authStore.currentInstanceIsMasterTenant && usePersonTypes.isClinician());

onBeforeMount(async () => {
  await serviceStore.getClinicianServices(hostId.value);
  await serviceStore.getOrganizationServices(orgId.value);
  eventTypes.value = [...Object.values(EVENT_TYPE)].map((value, index) => {
    return { id: index, label: value };
  });
  setOneYearAllowedDateRange();

  eventTypes.value = eventTypes.value.filter((eventType) => isAvailableService(eventType.label as string));

  if (isAttendeesSelectedFromDashboard.value) {
    await getServiceEventToBeSelected();

    await checkIfEventMatchesWithStudent(preselectedEventType.value as EVENT_TYPE);

    eventsModalsStore.loading = false;
  }

  newEvent.therapy_event_type =
    (preselectedEventType.value as EVENT_TYPE) ?? (eventTypes.value[0]?.label || EVENT_TYPE.SESSION);

  if (eventsModalsStore.preSelectedDueAt) {
    newEvent.due_at = eventsModalsStore.preSelectedDueAt;
  }

  const caseloadRequest = await therapyStore.getCaseloadManagementTypes();
  const sessionTypeRequest = await therapyStore.getSessionEventTypes();
  serviceProviderOrganizations.value = await clinicianOrganizationStore.getOrganizationsForClinician(hostId.value);

  setCaseloadOrganization();

  caseloadManagementTypes.value = caseloadRequest.map(({ id, name }) => {
    return {
      name: name as string,
      value: id,
    };
  });
  eventSessionTypes.value = sessionTypeRequest
    .map(({ id, name, acronym }) => {
      return {
        name: name as string,
        value: id,
        acronym,
      };
    })
    .sort((a, b) => a.value - b.value);

  if (therapyStore.allowedDateRange?.contract_windows.length) {
    const allTypes = therapyStore.allowedDateRange.contract_windows.flatMap((window) =>
      window.evaluation_types.map(({ id, title }) => ({
        name: title as string,
        value: id,
      })),
    );

    eventEvaluationTypes.value = [...new Map(allTypes.map((item) => [item.value, item])).values()];
  }

  evaluationAssessmentsTypesRequest.value = await therapyStore.getEvaluationAssessments();
  setAssessments();

  if (eventToEditSelected.value) {
    showEvaluationAssessmentsFiles.value = !!newEvent.assessment_record_form_id;
  } else {
    newEvent.session_types = [getTherapySessionTypeObject(0, eventSessionTypes.value[0].value)];

    newEvent.therapy_evaluation_type_id = therapyStore.eventEvaluations?.find(
      (evaluationType) => evaluationType.name === 'Regular',
    )?.value;
  }
});

/**
 * preset the dropdown selected org if the SP has ONE org OR
 * if there is an event being edited find the right Org connected to the event and populate it
 * if its a new event do not populate it
 */
const setCaseloadOrganization = () => {
  if (serviceProviderOrganizations.value.length === 1)
    caseloadOrganization.value = serviceProviderOrganizations.value[0];
  else if (eventToEdit.value) {
    const organization = eventToEdit?.value.attendees[0].organizations[0];
    caseloadOrganization.value = serviceProviderOrganizations.value.find((org) => {
      return org.id === organization.id;
    });
  }
};

/**
 *  loop through all the clinicians windows and match to allowed date ranges
 *  to find the latest date that matches for all eLuma tenant org contracts for events
 *  note: right now this is only for IEP meetings and could change in the future
 */
const setAllowedTherapyEventElumaContractRange = () => {
  let start = new Date();
  let end = new Date();
  const clinicianWindows = therapyStore.allowedDateRange?.clinician_windows;

  if (clinicianWindows?.length) {
    clinicianWindows.forEach((clinicianWindow) => {
      const [endYear, endMonth, endDay] = clinicianWindow.end_at.split('-').map(Number);
      const [startYear, startMonth, startDay] = clinicianWindow.start_at.split('-').map(Number);

      const newEnd = new Date(endYear, endMonth - 1, endDay, 23, 59, 59, 999);
      const newStart = new Date(startYear, startMonth - 1, startDay, 0, 0, 0, 0);

      if (newEnd > end) {
        end = newEnd;
        allowedDateRange.value.end = newEnd;
      }
      if (newStart < start) {
        start = newStart;
        allowedDateRange.value.start = newStart;
      }
    });

    verifySelectedDateIsWithinRange();
  }
};

/**
 * if the use selects IEP after selecting a date outside of the allowed contract params
 * then reset the selected date to today
 */
const verifySelectedDateIsWithinRange = () => {
  if (
    startCalendarModel.value < allowedDateRange.value.start ||
    startCalendarModel.value > allowedDateRange.value.end
  ) {
    startCalendarModel.value = new Date();
    endCalendarModel.value = new Date();
  }
};

/**
 * the default allowed date range for event creation === one year back and forward
 */
const setOneYearAllowedDateRange = () => {
  const today = new Date();
  const month = today.getMonth();
  const year = today.getFullYear();

  let prevMonth = month === 0 ? 11 : month;
  let prevYear = prevMonth === 11 ? year - 2 : year - 1;
  let nextMonth = month === 11 ? 0 : month + 1;
  let nextYear = nextMonth === 0 ? year + 2 : year + 1;
  originalAllowedDateRange.value = {
    start: new Date(prevYear, prevMonth, 1),
    end: new Date(nextYear, nextMonth, 0),
  };
  resetOneYearAllowedDateRange();
};

const resetOneYearAllowedDateRange = () => (allowedDateRange.value = { ...originalAllowedDateRange.value });

const isAvailableService = (label: string) => {
  return serviceStore.clinicianServices?.find((service) => service.name === label);
};

const selectedEventType: ComputedRef<{ id: number; label: EVENT_TYPE }> = computed(() => {
  const selected = eventTypes.value.find(
    (eventType) => (newEvent.therapy_event_type as EVENT_TYPE) === eventType.label,
  );
  return selected || eventTypes.value[0];
});

const { availableAttendees, availableDisciplines } = (
  ([__temp,__restore] = _withAsyncContext(() => useGetDropdownOptions(
  eventToEdit.value?.host_id || (authStore.user?.id as number),
  selectedDisciplineId as Ref<number>,
  selectedAttendees,
  selectedEventType,
  caseloadOrganization as Ref<ClinicianOrganizationInterface>,
  endCalendarModel,
))),
  __temp = await __temp,
  __restore(),
  __temp
);

watch(availableAttendees, () => {
  if (unref(eventToEditSelected) && availableAttendees.value.length && !eventDataSet.value) {
    eventsModalsStore.setAttendees(unref(availableAttendees));
    const event = unref(eventToEdit);
    setUpdatedEventData(event as DetailedEventInterface);
    eventDataSet.value = true;
  }
});

const selectedEventTypeIs = (eventType: EVENT_TYPE[]) => {
  return eventType.includes(selectedEventType.value?.label);
};

const getTherapySessionTypeObject = (personId: number, therapySessionTypeId: number) => {
  return { person_id: personId, therapy_session_type: { id: therapySessionTypeId } };
};

const duration = computed(() => {
  const startHour = startTimeElement.value?.currentHour <= 11 ? startTimeElement.value?.currentHour : 0;
  const startMinutes = startTimeElement.value?.currentMinute;
  const endHour = endTimeElement.value?.currentHour <= 11 ? endTimeElement.value?.currentHour : 0;
  const endMinutes = endTimeElement.value?.currentMinute;
  let diff = endHour * 60 + endMinutes - (startHour * 60 + startMinutes);

  if (startTimeElement.value?.pm === endTimeElement.value?.pm) {
    return diff || 0;
  } else {
    diff = (endHour + 12) * 60 + endMinutes - (startHour * 60 + startMinutes);

    return diff || 0;
  }
});

const newEvent: EventCreationFormInterface = reactive({
  rrule: eventRRule as Partial<RRule>,
  attendees: selectedAttendees,
  discipline_id: selectedDisciplineId.value as number,
  duration: duration,
  therapy_event_type: preselectedEventType.value ?? EVENT_TYPE.CASELOAD_MANAGEMENT,
  description: undefined,
  assessment_record_form_id: undefined,
  due_at: undefined,
  documents: [],
  session_types: [getTherapySessionTypeObject(0, 1)],
  therapy_evaluation_type_id: eventToEdit?.value?.event_type_data.therapy_evaluation_type_id
    ? eventToEdit?.value?.event_type_data.therapy_evaluation_type_id
    : undefined,
  therapy_caseload_management_types:
    eventToEdit?.value?.event_type_data && eventToEdit?.value?.event_type_data.therapy_caseload_management_types
      ? eventToEdit?.value?.event_type_data.therapy_caseload_management_types
      : undefined,
});

const untilLessThanStartDate = (value: Date) => {
  const until = new Date(value);
  const start = new Date((eventRRule.value?.options as RRule['options']).dtstart);
  const untilLaterThanStart = until > start;
  const untilHourGreaterThanStartHour = until.getHours() > start.getHours();
  const untilHourEqualToStartHour = until.getHours() == start.getHours();
  const untilMinuteGreaterThanStartMinute = until.getMinutes() > start.getMinutes();
  return (
    untilLaterThanStart &&
    (untilHourGreaterThanStartHour || (untilHourEqualToStartHour && untilMinuteGreaterThanStartMinute))
  );
};

const isWeeklyAndNoWeekdayChosen = (value: number[]) => {
  if ((eventRRule.value?.options as RRule['options']).freq === RRule.WEEKLY && isCustomRecurrence.value) {
    return !!value.length;
  } else {
    return true;
  }
};

const recurringWeekdayUpdate = (weekdays: number[]) =>
  ((eventRRule.value.options as RRule['options']).byweekday = weekdays as number[]);

const rules = computed(() => ({
  rrule: {
    options: {
      until: {
        requiredIfCustom: helpers.withMessage('Please specify a date after the start date', untilLessThanStartDate),
      },
      byweekday: {
        requiredIfCustom: helpers.withMessage('Please select a weekday', isWeeklyAndNoWeekdayChosen),
      },
    },
  },
  attendees: { required: helpers.withMessage('Please select an attendee(s)', required) },
  selected_evaluation_attendee: {
    requiredIfCustom: helpers.withMessage(
      'Please select an Attendee',
      requiredIf(() => selectedEventTypeIs([EVENT_TYPE.EVALUATION])),
    ),
  },
  duration: {
    lessThanEightHours: helpers.withMessage(
      'Event exceeds the maximum allowed duration of 8 hours. Please adjust start or end Time',
      maxValue(480),
    ),
  },
  discipline_id: {
    requiredIfCustom: helpers.withMessage(
      'Please select a Discipline',
      requiredIf(() => selectedEventTypeIs(disciplineAttendeeRequiredEventTypes as EVENT_TYPE[])),
    ),
  },
  description: {
    requiredIfCustom: helpers.withMessage(
      'Notes are required for this event type',
      requiredIf(() => selectedEventTypeIs([EVENT_TYPE.CASELOAD_MANAGEMENT])),
    ),
  },
  therapy_event_type: { required },
  assessment_record_form_id: {
    requiredIfCustom: helpers.withMessage(
      'Please select an Assessment',
      requiredIf(selectedEventTypeIs([EVENT_TYPE.EVALUATION])),
    ),
  },
  due_at: {
    requiredIfCustom: helpers.withMessage(
      'Please select a Due Date',
      requiredIf(selectedEventTypeIs([EVENT_TYPE.EVALUATION])),
    ),
  },
  therapy_evaluation_type_id: {
    requiredIfCustom: helpers.withMessage(
      'Please select an Evaluation Type',
      requiredIf(selectedEventTypeIs([EVENT_TYPE.EVALUATION])),
    ),
  },
  session_types: {
    requiredIfCustom: helpers.withMessage(
      'Please select a Session Type',
      requiredIf(selectedEventTypeIs([EVENT_TYPE.SESSION])),
    ),
  },
  therapy_caseload_management_types: {
    requiredIfCustom: helpers.withMessage(
      'Please select a Caseload Management type',
      requiredIf(selectedEventTypeIs([EVENT_TYPE.CASELOAD_MANAGEMENT])),
    ),
  },
}));

const v$ = useVuelidate(rules, newEvent, { $scope: v$scope });

const serviceDateErrors = computed(() => v$.value.$getResultsForChild(serviceDateErrorKey));

const init = async () => {
  if (unref(eventToEditSelected)) {
    const event = unref(eventToEdit);

    if (availableAttendees.value.length) {
      setUpdatedEventData(event as DetailedEventInterface);
      eventDataSet.value = true;
    }
  } else selectedAttendees.value = await eventsModalsStore.getPreSelectedAttendees();
};

const setUpdatedEventData = async (event: DetailedEventInterface) => {
  newEvent.therapy_evaluation_type_id = event.event_type_data?.therapy_evaluation_type_id;
  newEvent.therapy_event_type = event.therapy_event_type;

  const staticAvailableAttendees = availableAttendees.value.map((attendee) => ({ ...attendee }));

  selectedAttendees.value = [];
  event.attendees.forEach((attendee) => {
    const foundAttendee = availableAttendees.value.find((a) => a.value === attendee.attendee_id);
    if (foundAttendee) {
      const staticAttendee = staticAvailableAttendees.find((a) => a.value === foundAttendee.value);
      if (staticAttendee) {
        selectedAttendees.value.push({ ...staticAttendee, attendee_id: attendee.id });
      }
    }
  });

  evaluationEditAttendees.value = staticAvailableAttendees;

  if (selectedEventTypeIs([EVENT_TYPE.EVALUATION]) && selectedAttendees.value.length) {
    const selectedValue = selectedAttendees.value[0].value;
    newEvent.selected_evaluation_attendee = evaluationEditAttendees.value.find((a) => a.value === selectedValue);
    await getTherapyEventAllowedDateRange(selectedAttendees.value[0].organizations[0].id);
  }

  newEvent.attendees = selectedAttendees.value;
  const startAt = new Date(event.start_at);

  (eventRRule.value.options as Options).dtstart = new Date(
    Date.UTC(
      startAt.getUTCFullYear(),
      startAt.getUTCMonth(),
      startAt.getUTCDate(),
      eventRRule?.value?.options?.dtstart.getUTCHours(),
      eventRRule?.value?.options?.dtstart.getUTCMinutes(),
      0,
      0,
    ),
  );

  const dueAt = event.event_type_data?.due_at
    ? new Date(event.event_type_data?.due_at?.toString() as string)
    : undefined;
  const cmTypes = event.event_type_data?.therapy_caseload_management_types || [];
  selectedDisciplineId.value = event.discipline?.id as number;
  newEvent.discipline_id = event.discipline?.id as number;
  newEvent.description = getEventDescription(event);

  newEvent.assessment_record_form_id = (event.event_type_data?.assessment_record_form_id as number) || undefined;

  if (newEvent.assessment_record_form_id) {
    eventEvaluationAssessment.value = {
      name: `${event.event_type_data.assessment_record_form?.assessment?.title} - ${event.event_type_data.assessment_record_form.title}`,
      value: event.event_type_data.assessment_record_form.id,
    };
  }

  newEvent.due_at = dueAt || undefined;
  newEvent.therapy_evaluation_type_id = event.event_type_data?.therapy_evaluation_type_id || undefined;
  newEvent.documents = event.documents as File[];
  newEvent.session_types = Array.isArray(event.event_type_data?.session_types)
    ? event.event_type_data?.session_types
    : [getTherapySessionTypeObject(0, eventSessionTypes.value[0]?.value)];
  newEvent.therapy_caseload_management_types =
    cmTypes?.length > 1 ? (cmTypes?.map((item) => item.id) as number[]) : cmTypes[0]?.id;
};

watch(newEvent, (value) => {
  if (eventToEditSelected.value && eventToEdit?.value?.event_type_data && !!value.assessment_record_form_id) {
    showEvaluationAssessmentsFiles.value =
      value.assessment_record_form_id === eventToEdit?.value?.event_type_data.assessment_record_form_id;
  }
});

/**
 * watches for changes to discipline_id to shows only assessment of selected discipline
 */
watch(
  () => newEvent.discipline_id,
  (value) => {
    if (newEvent.discipline_id !== undefined) {
      const sourceAssessments = evaluationAssessmentsTypesRequest.value.filter(
        (item) => item.discipline_id === null || value === item.discipline_id,
      );
      setAssessments(sourceAssessments);
      if (!eventToEditSelected.value) {
        newEvent.assessment_record_form_id = undefined;
      }
    } else {
      setAssessments();
    }
  },
  { deep: true },
);

watch([endCalendarModel, startCalendarModel], async () => {
  if (!isElumaClinician.value || !hasCaseloadOrganizationId.value) return;
  isSplitCaseload.value = false;
  if (caseloadOrganization?.value && caseloadOrganization?.value.id) {
    await getTherapyEventAllowedDateRange(caseloadOrganization?.value.id);
  }

  checkForHourlyContractType();
  adjustDateLimit();
  checkContractDateValid(startCalendarModel.value);

  if (selectedEventTypeIs([EVENT_TYPE.CASELOAD_MANAGEMENT])) {
    checkCaseloadManagementDateValid(startCalendarModel.value);
  }
});

watch(
  caseloadOrganization as Ref<ClinicianOrganizationInterface>,
  async (newValue: ClinicianOrganizationInterface, oldValue: ClinicianOrganizationInterface) => {
    if (!isElumaClinician.value || !hasCaseloadOrganizationId.value) return;
    isSplitCaseload.value = false;

    await getTherapyEventAllowedDateRange(newValue.id);

    if (oldValue) checkForSplitCaseload(!!unref(oldValue).id);
    checkForHourlyContractType();
    adjustDateLimit();
  },
);

/**
 * watches if it is a custom recurrence or if the frequency is monthly
 * if this is the case, the byweekday property will be cleared out
 */
watchEffect(() => {
  if (eventRRule.value) {
    if (!isCustomRecurrence.value || eventRRule?.value?.options?.freq === RRule.MONTHLY) {
      (eventRRule.value.options as RRule['options']).byweekday = (
        eventRRule.value.origOptions as RRule['options']
      ).byweekday;
      (eventRRule.value.options as RRule['options']).bynweekday = null;
    }
  }
});

watchEffect(() => {
  if (
    unref(selectedAttendees).length === 1 &&
    selectedEventTypeIs([EVENT_TYPE.SESSION]) &&
    (newEvent.session_types as AttendeeSessionTypesData[]).length === 1
  ) {
    (newEvent.session_types as AttendeeSessionTypesData[])[0].person_id = unref(selectedAttendees)[0].value;
  }
});

// This computed ref is necessary to send updates to the SelectAttendees component
const isGroupEventType: ComputedRef<boolean> = computed(() => {
  return !selectedEventTypeIs([EVENT_TYPE.RECORD_REVIEW, EVENT_TYPE.CONSULTATION, EVENT_TYPE.EVALUATION]);
});

const updateAttendees = (attendees: AttendeeDropdownOptionInterface[]) => {
  v$.value.attendees.$touch();

  selectedAttendees.value = attendees;

  updateSessionTypesArray();
};

const getAttendeeWindow = async (attendee: Ref<AttendeeDropdownOptionInterface>) => {
  const evaluationAttendee = attendee.value;
  updateAttendees([evaluationAttendee]);
  await getTherapyEventAllowedDateRange(evaluationAttendee.organizations[0].id);
};

/**
 * if its caseload or evaluation we need the date ranges in the contract and evaluations allowed in that time
 * @param attendee
 */
const getTherapyEventAllowedDateRange = async (id: number) => {
  await therapyStore.getTherapyEventAllowedDateRange(id, dateUtil.formatDateForApi(startCalendarModel.value));
};

/**
 * if the user is a clinician in an org with an Eluma contract take the selected
 * students org id and get the allowed date range for IEP
 */
const adjustDateLimit = async () => {
  setAllowedTherapyEventElumaContractRange();
};

/**
 * checks the currently selected organization in cm events and determines whether they need
 * a single dropdown or a multiselect dropdown. split_caseload == true means singular dropdown
 */
const checkForSplitCaseload = async (clearAttendees = true) => {
  if (clearAttendees) newEvent.attendees = [];
  isSplitCaseload.value = !!therapyStore.allowedDateRange?.contract_windows[0]?.split_caseload;
};

const checkForHourlyContractType = () => {
  if (therapyStore.allowedDateRange?.contract_windows[0]?.contract_type === CONTRACT_BILLING_TYPE.HOURLY) {
    caseloadManagementTypes.value = therapyStore.allowedDateRange?.contract_windows[0]?.caseload_managements?.map(
      ({ id, name }) => {
        return {
          name: name as string,
          value: id,
        };
      },
    ) as { name: string; value: number }[];
  }
};

const updateDiscipline = () => {
  v$.value.discipline_id.$touch();
  selectedDisciplineId.value = newEvent.discipline_id;
};

const updateAttendeeSessionType = (attendeeSessionTypeObject: AttendeeSessionTypesData) => {
  const arrayIndex = newEvent.session_types?.findIndex((sessionTypeObject) => {
    return attendeeSessionTypeObject.person_id === sessionTypeObject.person_id;
  });
  if (Number(arrayIndex) > -1) {
    (newEvent.session_types as AttendeeSessionTypesData[])[Number(arrayIndex)].therapy_session_type.id =
      attendeeSessionTypeObject.therapy_session_type.id;
  }
};

const emitSaveNewEvent = async () => {
  const payload: EventCreationFormInterface = { ...newEvent };
  saving.value = true;
  if (unref(eventToEditSelected)) {
    await therapyStore
      .updateEvent(payload, unref(eventToEdit)?.id as number, unref(editEventConditions), unref(isRecurringEventEdit))
      .then(() => {
        emit(EMIT.SAVE_NEW_EVENT);
      })
      .catch((errors) => emit(EMIT.SAVE_EVENT_FAILED, errors));
  } else {
    await therapyStore
      .createEvent(payload, rRuleRef?.value?.id as number)
      .then(() => emit(EMIT.SAVE_NEW_EVENT))
      .catch((errors) => emit(EMIT.SAVE_EVENT_FAILED, errors));
  }
};

const emitCloseModal = () => {
  emit(EMIT.CLOSE_MODAL);

  if (isAttendeesSelectedFromDashboard.value) isAttendeesSelectedFromDashboard.value = false;
};

const emitDocumentEvent = () => emit(EMIT.DOCUMENT_EVENT);

const onCancelConfirm = () => (confirmEventOpen.value = false);

/**
 * reset the warning object
 */
const resetDateWarningMessage = () => {
  warningMessage.value = undefined;
  warningDetails.value = [];
};

const resetCMDateWarningMessage = () => {
  cmWarningMessage.value = undefined;
};

/**
 * check the selected Date to see if its within the params of the contract start/end
 * @param date
 */
const checkContractDateValid = (date: Date) => {
  if (therapyStore.allowedDateRange?.contract_windows[0]) {
    resetDateWarningMessage();
    showWarning.value = false;
    warningMessage.value = 'Event dates fall outside the contract dates';

    for (const range of therapyStore.allowedDateRange.contract_windows) {
      if (dateUtil.dateIsNotValidInWindow(range, date)) {
        warningDetails.value.push(`${range.start_at} to ${range.end_at}`);
        showWarning.value = true;
      } else {
        resetDateWarningMessage();
        showWarning.value = false;
        warningMessage.value = 'Event dates fall outside the contract dates';
        break;
      }
    }
  }
};

/**
 * check the selected Date to see if its within the params of the caseloadManagement start/end
 * 30 days in the past window
 * @param date
 */
const checkCaseloadManagementDateValid = (date: Date) => {
  if (therapyStore.allowedDateRange?.caseload_management_windows[0]) {
    const allowedDates = therapyStore.allowedDateRange?.caseload_management_windows[0];
    resetCMDateWarningMessage();
    showCMWarning.value = false;
    cmWarningMessage.value =
      'Caseload Management Events can only be created up to 30 days in the past, but can not be created in the future.';
    if (dateUtil.dateIsNotValidInWindow(allowedDates, date)) showCMWarning.value = true;
  }
};

// Since we have multiple calendar components, we cannot use the same
// v-model value for each since changing one will change the others.
// These are event handlers to manually change the eventRRule start
// or end dates without resetting the time values
const newStartDateSelected = (date: Date) => {
  checkContractDateValid(date);

  //if caseload mgmt event then check the date windows
  if (selectedEventTypeIs([EVENT_TYPE.CASELOAD_MANAGEMENT])) {
    checkCaseloadManagementDateValid(date);
  }

  const startHours = eventRRule.value.options?.dtstart.getHours() as number;
  const startMinutes = eventRRule.value.options?.dtstart.getMinutes() as number;
  date.setHours(startHours, startMinutes);
  if (eventRRule.value.options) {
    eventRRule.value.options.dtstart = date;
    // if the until value is less than the start date, or if this isn't a custom recurrence event
    // adjust the end date as well
    if (!isRecurring.value) newEndDateSelected(new Date(date));
    else if (
      ((eventRRule.value.options?.until as Date) < date ||
        !isCustomRecurrence.value ||
        !eventRRule.value.options?.count) &&
      !eventToEditSelected.value
    ) {
      setCalendarLastDayOfSchool(startHours, startMinutes);
    }
  }
};

const newEndDateSelected = (date: Date) => {
  checkContractDateValid(date);
  const hours = eventRRule.value.options?.until?.getHours();
  const minutes = eventRRule.value.options?.until?.getMinutes();
  date.setHours(hours as number, minutes);

  if (eventRRule.value.options) {
    endCalendarModel.value = date;
    eventRRule.value.options.until = date;
  }
};

const getServiceEventToBeSelected = async () => {
  const event = selectedAttendees.value.flatMap((attendee) => {
    return attendee.disciplines
      .filter((discipline) => discipline.is_active)
      .map((discipline) => discipline.service?.name);
  });

  if (!event.length) return (preselectedEventType.value = EVENT_TYPE.CASELOAD_MANAGEMENT as EVENT_TYPE);

  preselectedEventType.value = [
    EVENT_TYPE.SESSION,
    EVENT_TYPE.EVALUATION,
    EVENT_TYPE.RESPONSE_TO_INTERVENTION,
    EVENT_TYPE.CONSULTATION,
    EVENT_TYPE.IEP_MEETING,
    EVENT_TYPE.RECORD_REVIEW,
    EVENT_TYPE.CASELOAD_MANAGEMENT,
  ].find((eventType) => event.includes(eventType));
};
let attendeesSelectedFromDashboard = [...eventsModalsStore.preSelectedAttendees];

const checkIfEventMatchesWithStudent = async (label: EVENT_TYPE) => {
  const students: string[] = [];
  selectedAttendees.value = [...attendeesSelectedFromDashboard];
  attendeesSelectedFromDashboard.forEach((attendee) => {
    if (attendee.disciplines.length === 1) {
      attendee.disciplines.filter((discipline) => {
        if (label === EVENT_TYPE.CASELOAD_MANAGEMENT) {
          return (selectedAttendees.value = [...attendeesSelectedFromDashboard]);
        }

        const hasEqual = (discipline.service?.name === label && discipline.is_active) as boolean;
        if (!hasEqual) {
          students.push(attendee.name);
          selectedAttendees.value.splice(selectedAttendees.value.indexOf(attendee), 1);
        }
      });
    }

    if (attendee.disciplines.length > 1) {
      const hasTwoOrMoreDisciplines = attendee.disciplines.map(
        (discipline) => discipline.service?.name === label && discipline.is_active,
      );

      if (label === EVENT_TYPE.CASELOAD_MANAGEMENT) {
        return (selectedAttendees.value = [...attendeesSelectedFromDashboard]);
      }

      if (!hasTwoOrMoreDisciplines.includes(true)) {
        students.push(attendee.name);
        selectedAttendees.value.splice(selectedAttendees.value.indexOf(attendee), 1);
      }
    }
  });

  if (students.length) {
    students.length > 1
      ? (filteredMessage.value = `${
          students.slice(0, -1).join(', ') + ' and ' + students.at(-1)
        } do not have  ${label} in their treatment plan.`)
      : (filteredMessage.value = `${students} does not have ${label} in their treatment plan.`);
  }
};

const selectEventType = async (label: EVENT_TYPE) => {
  filteredMessage.value = '';
  showCMWarning.value = false;

  if (isAttendeesSelectedFromDashboard.value) {
    await checkIfEventMatchesWithStudent(label);
  } else {
    selectedAttendees.value = [];
  }
  selectedDisciplineId.value = undefined;
  newEvent.discipline_id = undefined;
  newEvent.description = '';
  newEvent.documents = [];
  newEvent.therapy_caseload_management_types = [];
  newEvent.session_types = eventSessionTypes.value.length
    ? [getTherapySessionTypeObject(0, eventSessionTypes.value[0].value)]
    : [];
  newEvent.therapy_event_type = label;

  resetOneYearAllowedDateRange();
  rRuleRef.value = recurrenceOptions.value[0];
  recurrenceUpdate(ref(recurrenceOptions.value[0]));
  v$.value.$reset();
  if (label === EVENT_TYPE.CASELOAD_MANAGEMENT) {
    checkCaseloadManagementDateValid(startCalendarModel.value);
  }
};

const uploadFiles = (event: FileUploadUploaderEvent) => (newEvent.documents = event.files as File[]);

const removeFile = (index: number) => newEvent.documents?.splice(index, 1);

const getAttendeeSessionType = (attendee: AttendeeDropdownOptionInterface) => {
  const arrayIndex = newEvent.session_types?.findIndex((sessionTypeObject) => {
    return attendee.value === sessionTypeObject.person_id;
  });
  if (Number(arrayIndex) > -1) {
    const attendeeSessionType = (newEvent.session_types as AttendeeSessionTypesData[])[Number(arrayIndex)];
    attendeeSessionType.person_id = attendee.value;
    return attendeeSessionType;
  }
  return getTherapySessionTypeObject(attendee.value, eventSessionTypes.value[0].value);
};

const checkDisabled = (sessionTypeId: number) => {
  if (!unref(newEvent.attendees).length) {
    return false;
  }
  const attendeeSessionType = unref(newEvent.attendees)[0].disciplines[0].treatment_service_type?.id;
  const regularSessionTypeId = eventSessionTypes.value.find((sessionType) => sessionType.name === 'Regular')?.value;
  const makeupSessionTypeId = eventSessionTypes.value.find((sessionType) => sessionType.name === 'Make up')?.value;

  return !(
    attendeeSessionType === sessionTypeId ||
    sessionTypeId === regularSessionTypeId ||
    sessionTypeId === makeupSessionTypeId
  );
};

const updateSessionTypesArray = () => {
  if (
    unref(selectedAttendees).length !== (newEvent.session_types as AttendeeSessionTypesData[]).length &&
    selectedEventTypeIs([EVENT_TYPE.SESSION])
  ) {
    const sessionTypeMatchArray: AttendeeSessionTypesData[] = [];
    unref(selectedAttendees).forEach((attendee) => {
      const attendeeSessionType = newEvent.session_types?.find((sessionTypeObject) => {
        return attendee.value === sessionTypeObject.person_id;
      });

      if (attendeeSessionType) sessionTypeMatchArray.push(attendeeSessionType);
      else {
        sessionTypeMatchArray.push(getTherapySessionTypeObject(attendee.value, eventSessionTypes.value[0].value));
      }
    });
    if (!sessionTypeMatchArray.length) {
      sessionTypeMatchArray.push(getTherapySessionTypeObject(0, eventSessionTypes.value[0].value));
    }
    newEvent.session_types = sessionTypeMatchArray;
  }
};

/**
 * when selecting reoccuring events in a school year limit to the upcoming school year of the
 * start date selected.
 */
const setCalendarLastDayOfSchool = (hours: number, minutes: number) => {
  if (eventRRule.value.options) {
    eventRRule.value.options.until = dateUtil.getLastSchoolDay(eventRRule.value.options?.dtstart);
    eventRRule.value.options.until.setHours(hours as number, (minutes as number) + duration.value);
    endCalendarModel.value = eventRRule.value.options.until;
  }
};

const recurrenceUpdate = (event: DropdownChangeEvent | Ref<RecurrenceDropdownOption>) => {
  const hours = eventRRule.value.options?.dtstart?.getHours() as number;
  const minutes = eventRRule.value.options?.dtstart?.getMinutes() as number;
  eventRRule.value = event.value.value;

  // If the non recurring option has been chosen, set the until date to dtstart date and add the duration
  if (!event.value.id && eventRRule.value.options?.until) {
    const eventRRuleOptions = JSON.parse(JSON.stringify(eventRRule.value.options));
    eventRRule.value.options.until = new Date(eventRRuleOptions.dtstart);

    eventRRule.value.options.until.setHours(hours as number, (minutes as number) + duration.value);
    endCalendarModel.value = eventRRule.value.options.until;
  } else if (event.value.id && eventRRule.value.options) {
    const sameDay = eventRRule.value.options.until?.getDay() == eventRRule.value.options.dtstart?.getDay();
    const sameMonth = eventRRule.value.options.until?.getMonth() == eventRRule.value.options.dtstart?.getMonth();

    // If a recurring option has been chosen, check to see if the until date should be set to the default
    // last day of school
    if (sameDay && sameMonth && event.value.value.options) setCalendarLastDayOfSchool(hours, minutes);
  }
};

const isRecurringEventEdit = computed<boolean>(() => {
  return (
    eventToEditSelected.value && !selectedEventTypeIs([EVENT_TYPE.CASELOAD_MANAGEMENT]) && eventToEdit?.value?.rrule
  );
});
const hasCaseloadError = computed(() => {
  const event = eventToEditSelected.value ? eventToEdit?.value : newEvent;
  return (
    selectedDisciplineId.value && !disciplineOnlyRequiredEventTypes.includes(event?.therapy_event_type as EVENT_TYPE)
  );
});

const sortedCaseloadManagementTypes = computed(() => {
  return [...caseloadManagementTypes.value].sort((a, b) => a.name.localeCompare(b.name));
});

const setAssessments = (sourceAssessments: AssessmentData[] | undefined = undefined) => {
  const filterAssessments = evaluationAssessmentsTypesRequest.value.filter(
    (item) =>
      item.discipline_id == null || availableDisciplines.value.some(({ value }) => value === item.discipline_id),
  );

  sourceAssessments = sourceAssessments === undefined ? filterAssessments : sourceAssessments;

  evaluationAssessments.value = sourceAssessments
    .map(({ title: assessmentTitle, assessment_record_forms }) => {
      return assessment_record_forms.map(({ id: formId, title: formTitle }) => ({
        name: `${assessmentTitle} ${formTitle == null ? '' : ' - ' + formTitle}`,
        value: formId,
      }));
    })
    .flat();

  if (eventEvaluationAssessment.value) {
    const hasAssessment = evaluationAssessments.value.findIndex(
      (item) => item.value === eventEvaluationAssessment.value.value,
    );

    if (hasAssessment < 0) {
      evaluationAssessments.value.push(eventEvaluationAssessment.value);
    }
  }

  evaluationAssessments.value.sort((a, b) => a.name.localeCompare(b.name));
};
const onClear = () => {
  preselectedEventType.value = undefined;
  isAttendeesSelectedFromDashboard.value = false;
  filteredMessage.value = '';
  preSelectedAttendees.value = [];
  newEvent.attendees = [];
  attendeesSelectedFromDashboard = [];
  onDismissMessage();
  v$.value.$reset();
};

const onDismissMessage = () => {
  filteredMessage.value = '';
};

const onDownloadDocument = async (id: number, name: string) => {
  await documentsStore.downloadDocument(id, name);
};

const hasCaseloadOrganizationId = computed(() => caseloadOrganization.value && caseloadOrganization.value.id);

const getEventDescription = (event: DetailedEventInterface): string => {
  return event.event_type_data?.description || '';
};

const handleOverlappingError = () => {
  if (!usePersonTypes.isSupportAdmin() && !usePersonTypes.isSuperAdmin()) overlappingError.value = true;
};

const handleOverlappingOk = () => {
  overlappingError.value = false;
};

onMounted(() => init());

onUnmounted(() => {
  onClear();
});

return (_ctx: any,_cache: any) => {
  const _component_Skeleton = _resolveComponent("Skeleton")!
  const _component_Message = _resolveComponent("Message")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Icon = _resolveComponent("Icon")!
  const _component_AppButton = _resolveComponent("AppButton")!
  const _component_ConfirmAction = _resolveComponent("ConfirmAction")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (loading.value)
    ? (_openBlock(), _createBlock(_component_Skeleton, {
        key: 0,
        class: "m-auto",
        width: "95%",
        height: "54vh",
        shape: "rectangle"
      }))
    : (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (!_unref(calendarStore).isCaseloadManagement(_unref(eventToEdit)?.therapy_event_type))
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(AppSelectButton, {
                items: eventTypes.value,
                "selected-item": selectedEventType.value?.id || 0,
                onSelectItem: _cache[0] || (_cache[0] = ($event: any) => (selectEventType($event.label as EVENT_TYPE)))
              }, null, 8, ["items", "selected-item"])
            ]))
          : _createCommentVNode("", true),
        (_unref(filteredMessage))
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_Message, {
                  severity: "warn",
                  onCloseOnce: onDismissMessage
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_5, [
                      _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(filteredMessage)), 1),
                      _cache[28] || (_cache[28] = _createElementVNode("div", { class: "mt-2 text-sm" }, [
                        _createElementVNode("span", null, "Please select a different event type or select a new student.")
                      ], -1))
                    ])
                  ]),
                  _: 1
                })
              ])
            ]))
          : _createCommentVNode("", true),
        (eventRRule.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _cache[29] || (_cache[29] = _createElementVNode("span", { class: "material-icons date-picker-icon mr-3" }, "event", -1)),
                  _createVNode(Calendar, {
                    modelValue: startCalendarModel.value,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((startCalendarModel).value = $event)),
                    "min-date": allowedDateRange.value.start,
                    "max-date": allowedDateRange.value.end,
                    class: _normalizeClass(["new-event-date", {
              'p-invalid': serviceDateErrors.value?.rrule.options.dtstart.$invalid,
            }]),
                    "date-format": "DD, MM dd",
                    onDateSelect: newStartDateSelected,
                    onBlur: _unref(v$).rrule.$touch
                  }, null, 8, ["modelValue", "min-date", "max-date", "class", "onBlur"]),
                  _createVNode(Calendar, {
                    ref_key: "startTimeElement",
                    ref: startTimeElement,
                    modelValue: (eventRRule.value.options as RRule['options']).dtstart,
                    "onUpdate:modelValue": [
                      _cache[2] || (_cache[2] = ($event: any) => (((eventRRule.value.options as RRule['options']).dtstart) = $event)),
                      newStartDateSelected
                    ],
                    class: _normalizeClass(["new-event-time", {
              'p-invalid': _unref(v$).duration.$invalid && _unref(v$).duration.$dirty,
            }]),
                    "input-class": "uppercase",
                    "time-only": true,
                    "hour-format": "12",
                    "step-minute": 5,
                    autocomplete: "off",
                    "min-date": allowedDateRange.value.start,
                    "max-date": allowedDateRange.value.end,
                    onBlur: _unref(v$).rrule.$touch
                  }, null, 8, ["modelValue", "class", "min-date", "max-date", "onBlur"]),
                  _cache[30] || (_cache[30] = _createElementVNode("span", { class: "new-event-separator" }, "to", -1)),
                  _createVNode(Calendar, {
                    ref_key: "endTimeElement",
                    ref: endTimeElement,
                    modelValue: (eventRRule.value.options as RRule['options']).until,
                    "onUpdate:modelValue": [
                      _cache[3] || (_cache[3] = ($event: any) => (((eventRRule.value.options as RRule['options']).until) = $event)),
                      newEndDateSelected
                    ],
                    class: _normalizeClass(["new-event-time text-sm", {
              'p-invalid':
                (_unref(v$).rrule.options.until.$invalid && _unref(v$).rrule.options.until.$dirty) ||
                (_unref(v$).duration.$invalid && _unref(v$).duration.$dirty),
            }]),
                    "input-class": "uppercase",
                    "time-only": true,
                    "hour-format": "12",
                    "step-minute": 5,
                    autocomplete: "off",
                    onBlur: _unref(v$).rrule.$touch
                  }, null, 8, ["modelValue", "class", "onBlur"]),
                  (hostTimezoneAbbr.value)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        class: "ml-2 font-bold",
                        textContent: _toDisplayString(hostTimezoneAbbr.value)
                      }, null, 8, _hoisted_10))
                    : _createCommentVNode("", true)
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(v$).rrule.$errors, (error) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: error.$uid,
                    class: "input-errors w-full ml-6"
                  }, [
                    _createElementVNode("div", _hoisted_11, _toDisplayString(error.$message), 1)
                  ]))
                }), 128)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(v$).duration.$errors, (error) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: error.$uid,
                    class: "input-errors w-full ml-6"
                  }, [
                    _createElementVNode("div", _hoisted_12, _toDisplayString(error.$message), 1)
                  ]))
                }), 128)),
                (!selectedEventTypeIs([_unref(EVENT_TYPE).CASELOAD_MANAGEMENT, _unref(EVENT_TYPE).RECORD_REVIEW]))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                      _createVNode(_component_Dropdown, {
                        modelValue: rRuleRef.value,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((rRuleRef).value = $event)),
                        "option-label": "label",
                        "data-key": "id",
                        options: _unref(recurrenceOptions),
                        class: "event-recurring-dropdown",
                        onChange: recurrenceUpdate
                      }, null, 8, ["modelValue", "options"])
                    ]))
                  : _createCommentVNode("", true),
                (!isCustomRecurrence.value && rRuleRef.value && !rRuleRef.value?.value.options?.count)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                      _cache[31] || (_cache[31] = _createElementVNode("span", { class: "new-event-separator" }, "until", -1)),
                      _createVNode(Calendar, {
                        modelValue: endCalendarModel.value,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((endCalendarModel).value = $event)),
                        class: _normalizeClass(["new-event-date", {
              'p-invalid':
                (_unref(v$).rrule.options.until.$invalid && _unref(v$).rrule.options.until.$dirty) ||
                serviceDateErrors.value?.rrule.options.until.$invalid,
            }]),
                        "date-format": "DD, MM dd",
                        onDateSelect: newEndDateSelected
                      }, null, 8, ["modelValue", "class"])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              (isCustomRecurrence.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, [
                      _cache[32] || (_cache[32] = _createElementVNode("label", { for: "interval" }, "Repeat every", -1)),
                      _createElementVNode("div", _hoisted_17, [
                        _createVNode(_unref(InputNumber), {
                          id: "interval",
                          modelValue: (eventRRule.value.options as RRule['options']).interval,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (((eventRRule.value.options as RRule['options']).interval) = $event)),
                          class: "w-3rem mr-2",
                          min: 1,
                          max: 12,
                          required: ""
                        }, null, 8, ["modelValue"]),
                        _createVNode(_component_Dropdown, {
                          id: "frequency",
                          modelValue: (eventRRule.value.options as RRule['options']).freq,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (((eventRRule.value.options as RRule['options']).freq) = $event)),
                          class: "event-recurring-dropdown border-none",
                          required: "",
                          "option-label": "label",
                          "option-value": "value",
                          options: frequencyIntervals.value,
                          placeholder: "Select Interval"
                        }, null, 8, ["modelValue", "options"])
                      ])
                    ]),
                    ((eventRRule.value.options as RRule['options']).freq === _unref(RRule).WEEKLY)
                      ? (_openBlock(), _createBlock(WeekdayPicker, {
                          key: 0,
                          class: _normalizeClass({
            'p-invalid': _unref(v$).rrule.options.byweekday.$invalid && _unref(v$).rrule.options.byweekday.$dirty,
          }),
                          "selected-values": (eventRRule.value.options as RRule['options']).byweekday || [],
                          onUpdate: recurringWeekdayUpdate
                        }, null, 8, ["class", "selected-values"]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_18, [
                      _cache[33] || (_cache[33] = _createElementVNode("label", { for: "ends_on" }, "Ends on", -1)),
                      _createVNode(Calendar, {
                        id: "ends_on",
                        modelValue: endCalendarModel.value,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((endCalendarModel).value = $event)),
                        class: _normalizeClass(["new-event-date", {
              'p-invalid':
                (_unref(v$).rrule.options.until.$invalid && _unref(v$).rrule.options.until.$dirty) ||
                serviceDateErrors.value?.rrule.options.until.$invalid,
            }]),
                        "date-format": "mm/dd/yy",
                        onDateSelect: newEndDateSelected
                      }, null, 8, ["modelValue", "class"])
                    ]),
                    (!isCustomRecurrence.value && rRuleRef.value && !rRuleRef.value?.value.options?.count)
                      ? (_openBlock(), _createBlock(Calendar, {
                          key: 1,
                          modelValue: endCalendarModel.value,
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((endCalendarModel).value = $event)),
                          class: _normalizeClass(["new-event-date", {
            'p-invalid':
              (_unref(v$).rrule.options.until.$invalid && _unref(v$).rrule.options.until.$dirty) ||
              serviceDateErrors.value?.rrule.options.until.$invalid,
          }]),
                          "date-format": "D, M dd",
                          onDateSelect: newEndDateSelected
                        }, null, 8, ["modelValue", "class"]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (hasCaseloadError.value && selectedEventType.value)
                ? (_openBlock(), _createBlock(ServiceDateError, {
                    key: 1,
                    rrule: eventRRule.value,
                    attendees: selectedAttendees.value,
                    "event-type": selectedEventType.value?.label,
                    "discipline-id": selectedDisciplineId.value,
                    "vuelidate-key": serviceDateErrorKey,
                    scope: v$scope
                  }, null, 8, ["rrule", "attendees", "event-type", "discipline-id"]))
                : _createCommentVNode("", true),
              (showWarning.value)
                ? (_openBlock(), _createBlock(CalendarWarning, {
                    key: 2,
                    message: warningMessage.value as string,
                    details: warningDetails.value
                  }, null, 8, ["message", "details"]))
                : _createCommentVNode("", true),
              (showCMWarning.value)
                ? (_openBlock(), _createBlock(CalendarWarning, {
                    key: 3,
                    message: cmWarningMessage.value as string
                  }, null, 8, ["message"]))
                : _createCommentVNode("", true),
              (duration.value && _unref($tenant).tenantSettingEnabled(_unref(TENANT_SETTINGS).OVERLAPPING_EVENTS))
                ? (_openBlock(), _createBlock(_unref(CalendarOverlappingEvents), {
                    key: 4,
                    duration: duration.value,
                    "event-id": _unref(eventToEdit)?.id,
                    "is-recurring": isRecurring.value,
                    rrule: eventRRule.value,
                    onError: handleOverlappingError,
                    onOk: handleOverlappingOk
                  }, null, 8, ["duration", "event-id", "is-recurring", "rrule"]))
                : _createCommentVNode("", true),
              (selectedEventTypeIs([_unref(EVENT_TYPE).EVALUATION]))
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                    _createElementVNode("div", _hoisted_19, [
                      _cache[34] || (_cache[34] = _createElementVNode("span", { class: "material-icons group-icon material-symbols-outlined mr-2 align-content-center" }, "person", -1)),
                      (_unref(eventToEditSelected))
                        ? (_openBlock(), _createBlock(_component_Dropdown, {
                            key: 0,
                            modelValue: newEvent.selected_evaluation_attendee,
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((newEvent.selected_evaluation_attendee) = $event)),
                            options: evaluationEditAttendees.value,
                            filter: "",
                            class: _normalizeClass(["w-full", { 'p-invalid': _unref(v$).selected_evaluation_attendee.$invalid && _unref(v$).selected_evaluation_attendee.$dirty }]),
                            "option-label": "name",
                            placeholder: "Select an Attendee",
                            blur: _unref(v$).selected_evaluation_attendee.$touch,
                            onChange: getAttendeeWindow
                          }, null, 8, ["modelValue", "options", "class", "blur"]))
                        : (_openBlock(), _createBlock(_component_Dropdown, {
                            key: 1,
                            modelValue: newEvent.selected_evaluation_attendee,
                            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((newEvent.selected_evaluation_attendee) = $event)),
                            options: _unref(availableAttendees),
                            filter: "",
                            class: _normalizeClass(["w-full", { 'p-invalid': _unref(v$).selected_evaluation_attendee.$invalid && _unref(v$).selected_evaluation_attendee.$dirty }]),
                            "option-label": "name",
                            placeholder: "Select an Attendee",
                            blur: _unref(v$).selected_evaluation_attendee.$touch,
                            onChange: getAttendeeWindow
                          }, null, 8, ["modelValue", "options", "class", "blur"]))
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(v$).selected_evaluation_attendee.$errors, (error) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: error.$uid,
                        class: "input-errors ml-6 mt-1"
                      }, [
                        _createElementVNode("div", _hoisted_20, _toDisplayString(error.$message), 1)
                      ]))
                    }), 128))
                  ], 64))
                : _createCommentVNode("", true),
              (selectedEventTypeIs(disciplineAttendeeRequiredEventTypes as EVENT_TYPE[]))
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
                    (selectedEventTypeIs([_unref(EVENT_TYPE).SESSION, _unref(EVENT_TYPE).RESPONSE_TO_INTERVENTION]))
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createVNode(_unref(SelectAttendees), {
                            "available-attendees": _unref(availableAttendees),
                            "selected-attendees": unref(newEvent.attendees),
                            "group-therapy": isGroupEventType.value,
                            "wrapper-class": "mt-4",
                            class: _normalizeClass({ 'p-invalid': _unref(v$).attendees.$invalid && _unref(v$).attendees.$dirty }),
                            blur: _unref(v$).attendees.$touch,
                            onUpdate: updateAttendees
                          }, null, 8, ["available-attendees", "selected-attendees", "group-therapy", "class", "blur"]),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(v$).attendees.$errors, (error) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: error.$uid,
                              class: "input-errors ml-6 mt-1"
                            }, [
                              _createElementVNode("div", _hoisted_21, _toDisplayString(error.$message), 1)
                            ]))
                          }), 128))
                        ], 64))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_22, [
                      _cache[35] || (_cache[35] = _createElementVNode("span", { class: "material-icons discipline-icon material-symbols-outlined mr-3" }, "work", -1)),
                      _createVNode(_component_Dropdown, {
                        id: "disciplines__dropdown",
                        modelValue: newEvent.discipline_id,
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((newEvent.discipline_id) = $event)),
                        class: _normalizeClass(["w-full", { 'p-invalid': _unref(v$).discipline_id.$invalid && _unref(v$).discipline_id.$dirty }]),
                        options: _unref(availableDisciplines),
                        "option-value": "value",
                        "option-label": "name",
                        placeholder: "Select a Discipline",
                        onBlur: _unref(v$).discipline_id.$touch,
                        onChange: updateDiscipline
                      }, null, 8, ["modelValue", "options", "class", "onBlur"])
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(v$).discipline_id.$errors, (error) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: error.$uid,
                        class: "input-errors ml-6 mt-1"
                      }, [
                        _createElementVNode("div", _hoisted_23, _toDisplayString(error.$message), 1)
                      ]))
                    }), 128))
                  ], 64))
                : _createCommentVNode("", true),
              (!selectedEventTypeIs([_unref(EVENT_TYPE).CASELOAD_MANAGEMENT]))
                ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                    _cache[36] || (_cache[36] = _createElementVNode("span", { class: "material-icons description-icon material-symbols-outlined mr-3 text-color-orange" }, "notes", -1)),
                    _createVNode(_unref(Textarea), {
                      modelValue: newEvent.description,
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((newEvent.description) = $event)),
                      class: "w-full",
                      rows: "1",
                      "auto-resize": true,
                      placeholder: "Add Description"
                    }, null, 8, ["modelValue"])
                  ]))
                : _createCommentVNode("", true),
              _createVNode(_unref(Divider), { class: "border-200" })
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_25, [
          (selectedEventTypeIs([_unref(EVENT_TYPE).SESSION]))
            ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                _createElementVNode("div", _hoisted_27, [
                  _cache[37] || (_cache[37] = _createElementVNode("label", { class: "font-semibold text-sm pr-1" }, "Session Type", -1)),
                  _withDirectives(_createVNode(_component_Icon, {
                    name: "info",
                    class: "session-type-info"
                  }, null, 512), [
                    [
                      _directive_tooltip,
                      sessionTypesTooltip,
                      void 0,
                      { top: true }
                    ]
                  ])
                ]),
                (unref(newEvent.attendees)?.length <= 1 && newEvent?.session_types?.length)
                  ? (_openBlock(), _createBlock(_component_Dropdown, {
                      key: 0,
                      modelValue: (newEvent.session_types as AttendeeSessionTypesData[])[0].therapy_session_type.id,
                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (((newEvent.session_types as AttendeeSessionTypesData[])[0].therapy_session_type.id) = $event)),
                      "option-value": "value",
                      "option-label": "name",
                      "option-disabled": (option) => checkDisabled(option.value),
                      class: _normalizeClass({
                'p-invalid': _unref(v$).session_types.$invalid && _unref(v$).session_types.$dirty,
              }),
                      options: eventSessionTypes.value,
                      onBlur: _unref(v$).session_types.$touch
                    }, null, 8, ["modelValue", "option-disabled", "class", "options", "onBlur"]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_28, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(unref(newEvent.attendees), (attendee) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: attendee.value
                        }, [
                          _createVNode(GroupSessionTypeSelect, {
                            attendee: attendee,
                            "event-session-types": eventSessionTypes.value,
                            "selected-session-type": getAttendeeSessionType(attendee),
                            onUpdate: updateAttendeeSessionType
                          }, null, 8, ["attendee", "event-session-types", "selected-session-type"])
                        ]))
                      }), 128))
                    ]))
              ]))
            : _createCommentVNode("", true),
          (selectedEventTypeIs([_unref(EVENT_TYPE).EVALUATION]))
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createElementVNode("div", _hoisted_29, [
                  _createElementVNode("div", _hoisted_30, [
                    _cache[38] || (_cache[38] = _createElementVNode("label", null, "Evaluation Type", -1)),
                    _createVNode(_component_Dropdown, {
                      id: "evaluation_input",
                      modelValue: newEvent.therapy_evaluation_type_id,
                      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((newEvent.therapy_evaluation_type_id) = $event)),
                      "option-value": "value",
                      "option-label": "name",
                      class: _normalizeClass({
                'p-invalid': _unref(v$).therapy_evaluation_type_id.$invalid && _unref(v$).therapy_evaluation_type_id.$dirty,
              }),
                      disabled: !selectedAttendees.value.length,
                      options: _unref(therapyStore).eventEvaluations,
                      onBlur: _unref(v$).therapy_evaluation_type_id.$touch
                    }, null, 8, ["modelValue", "class", "disabled", "options", "onBlur"])
                  ]),
                  _createElementVNode("div", _hoisted_31, [
                    _cache[39] || (_cache[39] = _createElementVNode("label", null, "Assessment", -1)),
                    _createVNode(_component_Dropdown, {
                      id: "assessment_input",
                      modelValue: newEvent.assessment_record_form_id,
                      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((newEvent.assessment_record_form_id) = $event)),
                      "option-value": "value",
                      "option-label": "name",
                      placeholder: "Select an Assessment",
                      filter: true,
                      "auto-filter-focus": true,
                      class: _normalizeClass({
                'p-invalid': _unref(v$).assessment_record_form_id.$invalid && _unref(v$).assessment_record_form_id.$dirty,
              }),
                      options: evaluationAssessments.value,
                      onBlur: _unref(v$).assessment_record_form_id.$touch
                    }, null, 8, ["modelValue", "class", "options", "onBlur"]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(v$).assessment_record_form_id.$errors, (error) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: error.$uid,
                        class: "input-errors mt-1"
                      }, [
                        _createElementVNode("div", _hoisted_32, _toDisplayString(error.$message), 1)
                      ]))
                    }), 128)),
                    (showEvaluationAssessmentsFiles.value)
                      ? (_openBlock(), _createBlock(EventEvaluationAssessmentsFiles, {
                          key: 0,
                          class: "mt-2",
                          event: _unref(eventToEdit)
                        }, null, 8, ["event"]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_33, [
                  _cache[40] || (_cache[40] = _createElementVNode("label", null, "Due Date", -1)),
                  _createVNode(Calendar, {
                    id: "due_date_input",
                    modelValue: newEvent.due_at,
                    "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((newEvent.due_at) = $event)),
                    class: _normalizeClass(["new-event-date", { 'p-invalid': _unref(v$).due_at.$invalid && _unref(v$).due_at.$dirty }]),
                    "date-format": "D, M dd",
                    onBlur: _unref(v$).due_at.$touch
                  }, null, 8, ["modelValue", "class", "onBlur"]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(v$).due_at.$errors, (error) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: error.$uid,
                      class: "input-errors mt-1"
                    }, [
                      _createElementVNode("div", _hoisted_34, _toDisplayString(error.$message), 1)
                    ]))
                  }), 128))
                ])
              ], 64))
            : _createCommentVNode("", true),
          (selectedEventTypeIs([_unref(EVENT_TYPE).CASELOAD_MANAGEMENT]))
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                _createElementVNode("div", _hoisted_35, [
                  _cache[41] || (_cache[41] = _createElementVNode("label", { for: "caseloadOrganization_single" }, "Organization", -1)),
                  _createVNode(_component_Dropdown, {
                    id: "caseloadOrganization_single",
                    modelValue: caseloadOrganization.value,
                    "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((caseloadOrganization).value = $event)),
                    options: filteredServiceProviderOrganizations.value,
                    class: "w-full",
                    "panel-class": "new-event-attendee-select",
                    "data-key": "id",
                    "option-label": "name",
                    filter: true,
                    placeholder: "Select Organization"
                  }, null, 8, ["modelValue", "options"])
                ]),
                (!isSplitCaseload.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                      _cache[42] || (_cache[42] = _createElementVNode("label", { for: "regarding_multi" }, "Regarding", -1)),
                      _createVNode(_unref(MultiSelect), {
                        id: "regarding_multi",
                        modelValue: newEvent.attendees,
                        "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((newEvent.attendees) = $event)),
                        options: _unref(availableAttendees),
                        class: _normalizeClass(["w-full", { 'p-invalid': _unref(v$).attendees.$invalid && _unref(v$).attendees.$dirty }]),
                        "panel-class": "new-event-attendee-select",
                        "data-key": "value",
                        "option-label": "name",
                        filter: true,
                        display: "chip",
                        placeholder: "Add People",
                        disabled: !hasCaseloadOrganizationId.value,
                        onBlur: _unref(v$).attendees.$touch
                      }, null, 8, ["modelValue", "options", "disabled", "class", "onBlur"]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(v$).attendees.$errors, (error) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: error.$uid,
                          class: "input-errors mt-1"
                        }, [
                          _createElementVNode("div", _hoisted_37, _toDisplayString(error.$message), 1)
                        ]))
                      }), 128))
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_38, [
                      _cache[43] || (_cache[43] = _createElementVNode("label", { for: "regarding_single_cm" }, "Regarding", -1)),
                      _createVNode(_component_Dropdown, {
                        id: "regarding_single_cm",
                        modelValue: newEvent.attendees[0],
                        "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((newEvent.attendees[0]) = $event)),
                        options: _unref(availableAttendees),
                        class: _normalizeClass(["w-full", { 'p-invalid': _unref(v$).attendees.$invalid && _unref(v$).attendees.$dirty }]),
                        "panel-class": "new-event-attendee-select",
                        "data-key": "value",
                        "option-label": "name",
                        filter: true,
                        placeholder: "Select Person",
                        onHide: _unref(v$).attendees.$touch
                      }, null, 8, ["modelValue", "options", "class", "onHide"]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(v$).attendees.$errors, (error) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: error.$uid,
                          class: "input-errors mt-1"
                        }, [
                          _createElementVNode("div", _hoisted_39, _toDisplayString(error.$message), 1)
                        ]))
                      }), 128))
                    ])),
                _createElementVNode("div", _hoisted_40, [
                  _cache[44] || (_cache[44] = _createElementVNode("label", null, "Caseload Management Type", -1)),
                  (
              Array.isArray(newEvent.therapy_caseload_management_types) &&
              newEvent.therapy_caseload_management_types.length > 1
            )
                    ? (_openBlock(), _createBlock(_unref(MultiSelect), {
                        key: 0,
                        modelValue: newEvent.therapy_caseload_management_types,
                        "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((newEvent.therapy_caseload_management_types) = $event)),
                        options: sortedCaseloadManagementTypes.value,
                        "option-label": "name",
                        "option-value": "value",
                        class: _normalizeClass({
                'p-invalid':
                  _unref(v$).therapy_caseload_management_types.$invalid && _unref(v$).therapy_caseload_management_types.$dirty,
              }),
                        placeholder: "Select Caseload Management Types",
                        display: "chip",
                        onBlur: _unref(v$).therapy_caseload_management_types.$touch
                      }, null, 8, ["modelValue", "options", "class", "onBlur"]))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createVNode(_component_Dropdown, {
                          modelValue: newEvent.therapy_caseload_management_types,
                          "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((newEvent.therapy_caseload_management_types) = $event)),
                          options: sortedCaseloadManagementTypes.value,
                          "option-label": "name",
                          "option-value": "value",
                          class: _normalizeClass({
                'p-invalid':
                  _unref(v$).therapy_caseload_management_types.$invalid && _unref(v$).therapy_caseload_management_types.$dirty,
              }),
                          placeholder: "Select Caseload Management Type",
                          onBlur: _unref(v$).therapy_caseload_management_types.$touch
                        }, null, 8, ["modelValue", "options", "class", "onBlur"]),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(v$).therapy_caseload_management_types.$errors, (error) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: error.$uid,
                            class: "input-errors mt-1"
                          }, [
                            _createElementVNode("div", _hoisted_41, _toDisplayString(error.$message), 1)
                          ]))
                        }), 128))
                      ], 64))
                ]),
                _createElementVNode("div", _hoisted_42, [
                  _cache[45] || (_cache[45] = _createElementVNode("label", { for: "notes_input" }, "Notes", -1)),
                  _createVNode(_unref(Textarea), {
                    id: "notes_input",
                    modelValue: newEvent.description,
                    "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((newEvent.description) = $event)),
                    class: _normalizeClass(["w-full", { 'p-invalid': _unref(v$).description.$invalid && _unref(v$).description.$dirty }]),
                    rows: "3",
                    "auto-resize": true,
                    placeholder: "Add Notes",
                    onBlur: _unref(v$).description.$touch
                  }, null, 8, ["modelValue", "class", "onBlur"]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(v$).description.$errors, (error) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: error.$uid,
                      class: "input-errors mt-1"
                    }, [
                      _createElementVNode("div", _hoisted_43, _toDisplayString(error.$message), 1)
                    ]))
                  }), 128))
                ])
              ], 64))
            : _createCommentVNode("", true),
          (selectedEventTypeIs([_unref(EVENT_TYPE).RECORD_REVIEW, _unref(EVENT_TYPE).IEP_MEETING, _unref(EVENT_TYPE).CONSULTATION]))
            ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                _cache[46] || (_cache[46] = _createElementVNode("label", { for: "regarding_single" }, "Regarding", -1)),
                _createVNode(_component_Dropdown, {
                  id: "regarding_single",
                  modelValue: newEvent.attendees[0],
                  "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((newEvent.attendees[0]) = $event)),
                  options: _unref(availableAttendees),
                  class: _normalizeClass(["w-full", { 'p-invalid': _unref(v$).attendees.$invalid && _unref(v$).attendees.$dirty }]),
                  "panel-class": "new-event-attendee-select",
                  "data-key": "value",
                  "option-label": "name",
                  filter: true,
                  placeholder: "Select Person",
                  onHide: _unref(v$).attendees.$touch
                }, null, 8, ["modelValue", "options", "class", "onHide"]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(v$).attendees.$errors, (error) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: error.$uid,
                    class: "input-errors mt-1"
                  }, [
                    _createElementVNode("div", _hoisted_45, _toDisplayString(error.$message), 1)
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          (selectedEventTypeIs(uploadFileEventTypes))
            ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                _createVNode(_unref(FileUpload), {
                  mode: "basic",
                  accept: ".pdf, .doc, .docx",
                  class: "bg-white border-none text-sm font-semibold cursor-pointer",
                  name: "demo[]",
                  "choose-label": "Upload File",
                  "upload-icon": "pi pi-plus",
                  multiple: true,
                  "custom-upload": true,
                  auto: true,
                  "max-file-size": 100000000,
                  "invalid-file-size-message": "Error: This file exceeds the max file size allowed.",
                  onUploader: uploadFiles
                }),
                _cache[47] || (_cache[47] = _createElementVNode("div", { class: "mt-1 ml-3 m-3 text-xs text-600" }, [
                  _createElementVNode("p", null, "Allowed types: .pdf, .doc, .docx"),
                  _createElementVNode("p", null, "Max File size: 100MB")
                ], -1)),
                (newEvent.documents?.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(newEvent.documents, (upload, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: upload.name + index,
                          class: "inline-flex justify-content-between w-full text-sm text-color-gray-dark"
                        }, [
                          _createElementVNode("div", _hoisted_48, [
                            _createVNode(_component_Icon, {
                              name: "insert_drive_file",
                              class: "mr-2 material-symbols-outlined"
                            }),
                            _createElementVNode("span", {
                              class: "mt-1 download cursor-pointer",
                              onClick: ($event: any) => (onDownloadDocument(upload.id, upload.name)),
                              textContent: _toDisplayString(upload.name)
                            }, null, 8, _hoisted_49)
                          ]),
                          (upload.size)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: "col-2 mt-1",
                                textContent: _toDisplayString(`${upload.size} KB`)
                              }, null, 8, _hoisted_50))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_51, [
                            _createVNode(_component_Icon, {
                              name: "close",
                              class: "cursor-pointer",
                              onClick: ($event: any) => (removeFile(index))
                            }, null, 8, ["onClick"])
                          ])
                        ]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_52, [
          (_unref(eventToEditSelected) && !selectedEventTypeIs([_unref(EVENT_TYPE).CASELOAD_MANAGEMENT]))
            ? (_openBlock(), _createBlock(_component_AppButton, {
                key: 0,
                type: "secondary",
                text: "Document",
                "icon-left": "edit_note",
                onClick: emitDocumentEvent
              }))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_53, [
            _createVNode(_component_AppButton, {
              type: "secondary",
              text: "Cancel",
              onClick: emitCloseModal
            }),
            (isRecurringEventEdit.value)
              ? (_openBlock(), _createBlock(_component_AppButton, {
                  key: 0,
                  type: "primary",
                  text: "Save",
                  disabled: _unref(v$).$invalid || showWarning.value || showCMWarning.value || overlappingError.value,
                  onClick: _cache[25] || (_cache[25] = ($event: any) => (confirmEventOpen.value = true))
                }, null, 8, ["disabled"]))
              : (_openBlock(), _createBlock(_component_AppButton, {
                  key: 1,
                  type: "primary",
                  text: "Save",
                  disabled: _unref(v$).$invalid || showWarning.value || showCMWarning.value || overlappingError.value,
                  onClick: emitSaveNewEvent
                }, null, 8, ["disabled"]))
          ])
        ]),
        _createElementVNode("div", null, [
          (confirmEventOpen.value)
            ? (_openBlock(), _createBlock(_component_ConfirmAction, {
                key: 0,
                header: "Edit Recurring Event",
                "accept-label": "Save",
                onAccept: emitSaveNewEvent,
                onCancel: onCancelConfirm
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_54, [
                    _createElementVNode("div", _hoisted_55, [
                      _createVNode(_unref(RadioButton), {
                        modelValue: editEventConditions.value,
                        "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((editEventConditions).value = $event)),
                        "input-id": "editThis",
                        value: "this"
                      }, null, 8, ["modelValue"]),
                      _cache[48] || (_cache[48] = _createElementVNode("label", {
                        for: "editThis",
                        class: "ml-2"
                      }, "This event", -1))
                    ]),
                    _createElementVNode("div", null, [
                      _createVNode(_unref(RadioButton), {
                        modelValue: editEventConditions.value,
                        "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((editEventConditions).value = $event)),
                        "input-id": "editAll",
                        value: "future"
                      }, null, 8, ["modelValue"]),
                      _cache[49] || (_cache[49] = _createElementVNode("label", {
                        for: "editAll",
                        class: "ml-2"
                      }, "This and following events", -1))
                    ])
                  ])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ])
      ]))
}
}

})